import { ERROR } from '../constants/MessageType';
let incrementingId = 0;
export const createErrorMessage = (source, threadId) => ({
  actions: [],
  displayType: 'ERROR_MESSAGE',
  id: incrementingId++,
  query: {
    intent: 'unknown'
  },
  source,
  status: 'error',
  response: 'There was an issue connecting to our service. Please try again in a few minutes.',
  value: 'There was an issue connecting to our service. Please try again in a few minutes.',
  time: Date.now(),
  thread_id: threadId,
  type: ERROR
});